

export type ComparisonBarProduct = {
  sku: string;
  name: string;
  cover: string | null;
}

export const COMPARE_PRODUCTS_COOKIE_NAME = 'compare_products';
